import { CoreDataSecurityApplicationsName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityApplications } from '@api/data-security';
import { updateApplicationReferences } from './_idMap/actions';

export const getCoreDataSecurityApplicationsSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successDataActionCreators: [ (response) => updateApplicationReferences(response.results) ]
	},
	name: CoreDataSecurityApplicationsName,
	receive: true,
	request: true,
	requestHandler: getDataSecurityApplications,
	retainDataOnRequest: true
});
